var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLearning = function SvgLearning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M10 4a2.1 2.1 0 0 0-.666.11l-7.89 2.713A.65.65 0 0 0 1 7.428c0 .27.178.511.445.605l1.628.56a4.26 4.26 0 0 0-.723 2.367v.753c0 .76-.303 1.545-.627 2.164-.183.348-.39.69-.633 1.007a.42.42 0 0 0-.064.401c.05.137.168.239.315.273l1.8.429c.118.03.244.008.348-.054a.42.42 0 0 0 .2-.278 6.6 6.6 0 0 0-.059-2.911c-.09-.38-.21-.769-.38-1.125v-.659c0-.809.287-1.572.785-2.182.363-.415.833-.75 1.384-.956l4.415-1.653a.457.457 0 0 1 .582.241.42.42 0 0 1-.253.555L5.748 8.617a2.6 2.6 0 0 0-.906.578l4.489 1.543a2.08 2.08 0 0 0 1.333 0l7.892-2.705A.645.645 0 0 0 19 7.428a.65.65 0 0 0-.444-.605l-7.89-2.713A2.1 2.1 0 0 0 10 4M4.6 14.07c0 .945 2.419 1.928 5.4 1.928s5.4-.983 5.4-1.928l-.43-3.894-4 1.376a3 3 0 0 1-1.94 0l-4-1.376z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLearning);
export default ForwardRef;